import * as tslib_1 from "tslib";
import { deepMerge } from '../../../../helpers';
/**
 * @export
 * @class BaseApiClient
 */
var BaseApiClient = /** @class */ (function () {
    function BaseApiClient(configuration, ajaxService) {
        this.ajaxService = ajaxService;
        this.configuration = configuration;
    }
    /**
     * Prepare URL and options for AJAX request
     * @param request
     */
    BaseApiClient.prototype.getFetchOptions = function (request) {
        return {
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Authorization": "Bearer " + this.configuration.accessToken,
                "locale": this.configuration.locale,
            },
            body: JSON.stringify(request || {})
        };
    };
    /**
     * Execute AJAX request to BFF
     * @param url BFF endpoint
     * @param request Request object to be send
     */
    BaseApiClient.prototype.executeRequest = function (url, fetchOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var fetchUrl, options, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fetchUrl = this.configuration.basePath + url;
                        options = this.getFetchOptions(fetchOptions.request);
                        if (fetchOptions) {
                            options = deepMerge(options, fetchOptions.fetchOptOverride);
                        }
                        if (options.method === 'GET' || options.method === 'HEAD') {
                            delete options.body;
                        }
                        return [4 /*yield*/, this.ajaxService.send(fetchUrl, options)];
                    case 1:
                        response = _a.sent();
                        if (!(response.status >= 200 && response.status < 300)) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: throw response;
                }
            });
        });
    };
    BaseApiClient.prototype.refreshToken = function (token) {
        this.configuration.accessToken = token;
        return this;
    };
    return BaseApiClient;
}());
export { BaseApiClient };
;
//# sourceMappingURL=BaseApiClient.js.map